import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=010b8044&"
import script from "./EmailConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010b8044')) {
      api.createRecord('010b8044', component.options)
    } else {
      api.reload('010b8044', component.options)
    }
    module.hot.accept("./EmailConfirm.vue?vue&type=template&id=010b8044&", function () {
      api.rerender('010b8044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/EmailConfirm.vue"
export default component.exports